var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "right-body",
      attrs: {
        id: "rightBodyList",
        "element-loading-background": "rgba(0, 0, 0, 0)"
      },
      on: { click: _vm.filterMenuClose }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.haveTaskData == 1,
              expression: "haveTaskData==1"
            },
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.deleteloading,
              expression: "deleteloading"
            }
          ],
          staticClass: "right-body-box",
          attrs: { "element-loading-background": "rgba(0, 0, 0, 0.05)" }
        },
        [
          _c("div", { staticClass: "right-task-list" }, [
            _c("div", { staticClass: "task-list-title" }, [
              _c("div", { staticClass: "list-des-position" }, [
                _c("div", { staticClass: "title-des" }, [
                  _vm._v(_vm._s(_vm.$t("language.leftBanner.taskList")))
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(_vm._s(_vm.$t("language.taskList.taskListDes")))
                ])
              ]),
              _vm._v(" "),
              _vm.allTaskData.length > 5
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "clickoutside",
                          rawName: "v-clickoutside",
                          value: _vm.filterMenuClose,
                          expression: "filterMenuClose"
                        },
                        {
                          name: "rightclickoutside",
                          rawName: "v-rightclickoutside",
                          value: _vm.dateControlsClose,
                          expression: "dateControlsClose"
                        }
                      ],
                      staticClass: "task-list-icons"
                    },
                    [
                      _c("div", {
                        staticClass: " task-list-edit-position",
                        class: _vm.eidtTaskFlag
                          ? "icon-util task-list-edit-forbid "
                          : "task-list-edit ",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.eidtTaskFlag = !_vm.eidtTaskFlag
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "icon-util funnel",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.filterMenuShow = true
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.filterMenuShow,
                              expression: "filterMenuShow"
                            }
                          ],
                          staticClass: "filter-menu"
                        },
                        _vm._l(_vm.filterArr, function(filterType, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "filter-menu-item",
                              on: {
                                mouseenter: function($event) {
                                  return _vm.switchMenu(index)
                                },
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.switchMenu(index)
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "icon-util filter-triangle filter-triangle-position"
                              }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(filterType) +
                                  "\n            "
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm.filterIndex == 0
                        ? _c(
                            "div",
                            { staticClass: "type-menu" },
                            _vm._l(_vm.typeArr, function(typeItem, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "type-menu-item",
                                  class: {
                                    "type-menu-checked": _vm.typeClick == index
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.selectTypeFilters(
                                        typeItem,
                                        index
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "icon-util tick-purple-position",
                                    class: {
                                      "tick-purple": _vm.typeClick == index
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "filter-type-name" },
                                    [_vm._v(_vm._s(typeItem))]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.filterIndex == 1,
                              expression: "filterIndex==1"
                            }
                          ],
                          staticClass: "type-menu"
                        },
                        _vm._l(_vm.dateArr, function(dateItem, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "type-menu-item",
                              class: {
                                "type-menu-checked": _vm.dateClick == index
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.selectDateFilters(dateItem, index)
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "icon-util tick-purple-position",
                                class: { "tick-purple": _vm.dateClick == index }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "filter-type-name" }, [
                                _vm._v(_vm._s(dateItem))
                              ])
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm.filterIndex == 2
                        ? _c(
                            "div",
                            { staticClass: "type-menu" },
                            _vm._l(_vm.statusArr, function(statusItem, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "type-menu-item",
                                  class: {
                                    "type-menu-checked":
                                      _vm.statusClick == index
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.selectStatusFilters(
                                        statusItem,
                                        index
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "icon-util tick-purple-position",
                                    class: {
                                      "tick-purple": _vm.statusClick == index
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "filter-type-name" },
                                    [_vm._v(_vm._s(statusItem))]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.timeSetShow
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "clickoutside",
                                  rawName: "v-clickoutside",
                                  value: _vm.dateControlsClose,
                                  expression: "dateControlsClose"
                                }
                              ],
                              staticClass: "time-set",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.reSet()
                                }
                              }
                            },
                            [
                              _c("date-selector", {
                                ref: "minDate",
                                staticStyle: { margin: "8Px 8Px 8Px 10Px" },
                                on: { changeDate: _vm.changeMinDate }
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "icon-util arrow-purple arrow-purple-position"
                              }),
                              _vm._v(" "),
                              _c("date-selector", {
                                ref: "maxDate",
                                staticStyle: { margin: "8Px 19Px 8Px 8Px" },
                                on: { changeDate: _vm.changeMaxDate }
                              }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "time-set-button",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.filterMenuOpen()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "task-list-all" }, [
            _c(
              "div",
              {
                class: _vm.eidtTaskFlag
                  ? "task-list-edit-contens"
                  : "task-list-contens"
              },
              _vm._l(_vm.tasklistData, function(item, index) {
                return _c(
                  "div",
                  {
                    key: item.id,
                    ref: "allcollapsebox",
                    refInFor: true,
                    class: [
                      _vm.collapseFlage == index &&
                      _vm.detailShow &&
                      (item.type == 1 || item.type == 6) &&
                      item.transferDetail
                        ? "single-from-collapse-box"
                        : "edit-all-box",
                      _vm.collapseFlage == index &&
                      _vm.detailShow &&
                      item.type == 2
                        ? "single-to-collapse-box"
                        : ""
                    ],
                    style: { height: _vm.getContectHeight(item, index) },
                    on: {
                      click: function($event) {
                        return _vm.selectItem(item)
                      }
                    }
                  },
                  [
                    _c("singleTask", {
                      ref: "singleTask",
                      refInFor: true,
                      attrs: {
                        item: item,
                        collapseFlage: _vm.collapseFlage,
                        eidtTaskFlag: _vm.eidtTaskFlag,
                        detailShow: _vm.detailShow,
                        index: index,
                        tasklistData: _vm.tasklistData
                      }
                    })
                  ],
                  1
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _vm.eidtTaskFlag
            ? _c("div", { staticClass: "eidt-task-bottom" }, [
                _c(
                  "button",
                  {
                    staticClass: "select-all-button",
                    attrs: { id: "allButton" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.selectAll()
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "icon-util white-tick",
                      attrs: { id: "whiteTick" }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "icon-util purple-tick",
                      attrs: { id: "purpleTick" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "operate-option" }, [
                      _vm._v(_vm._s(_vm.$t("language.common.selectAll")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "task-delete-button",
                    attrs: { id: "deleteButton" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.deleteAllItem()
                      }
                    }
                  },
                  [
                    _c("div", {
                      staticClass: "icon-util white-fork  delete-one",
                      attrs: { id: "whiteFork" }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "icon-util purple-fork  delete-two",
                      attrs: { id: "purpleFork" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "operate-option" }, [
                      _vm._v(_vm._s(_vm.$t("language.common.delete")))
                    ])
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("deleteTaskDialog", { ref: "deleteTaskDialog" }),
          _vm._v(" "),
          _c("deleteSelectedTaskDialog", { ref: "deleteSelectedTaskDialog" }),
          _vm._v(" "),
          _c("upgradeNewDialog", { ref: "upgradeNewDialog" }),
          _vm._v(" "),
          _c("noticeDialog", { ref: "noticeDialog" }),
          _vm._v(" "),
          _c("renameDialog", { ref: "renameDialog" }),
          _vm._v(" "),
          _c("backupSourceFilesDialog", { ref: "backupSourceFilesDialog" }),
          _vm._v(" "),
          _c("restoreAimMoreDialog", { ref: "restoreAimMoreDialog" })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.haveTaskData == 2,
              expression: "haveTaskData==2"
            },
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "task-list-welcome"
        },
        [
          _c("div", { staticClass: "welcome-opreation" }, [
            _c("div", { staticClass: "welcome-task-list" }, [
              _vm._v(_vm._s(_vm.$t("language.taskList.noTaskCreated")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "welcome-task" }, [
              _c(
                "button",
                {
                  staticClass: "welcome-task-button",
                  class: [
                    _vm.$i18n.locale == "deutsch" ? "deu-class" : "",
                    _vm.languaArr.includes(_vm.$i18n.locale)
                      ? "other-language"
                      : ""
                  ],
                  on: {
                    click: function($event) {
                      return _vm.goToTransferPage()
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "icon task-list-icon-position cloudTransfer"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "welcome-font-position" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.taskList.createTransferTask"))
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "welcome-task" }, [
              _c(
                "button",
                {
                  staticClass: "welcome-task-button",
                  class: [
                    _vm.$i18n.locale == "deutsch" ? "deu-class" : "",
                    _vm.languaArr.includes(_vm.$i18n.locale)
                      ? "other-language"
                      : ""
                  ],
                  on: {
                    click: function($event) {
                      return _vm.goTeamTransferPage()
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "icon task-list-icon-position teamTransfer"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "welcome-font-position" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.taskList.createTeamTransferTask"))
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "welcome-task" }, [
              _c(
                "button",
                {
                  staticClass: "welcome-task-button",
                  class: [
                    _vm.$i18n.locale == "deutsch" ? "deu-class" : "",
                    _vm.languaArr.includes(_vm.$i18n.locale)
                      ? "other-language"
                      : ""
                  ],
                  on: {
                    click: function($event) {
                      return _vm.goToSyncPage()
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "icon task-list-icon-position cloudsync"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "welcome-font-position" }, [
                    _vm._v(_vm._s(_vm.$t("language.taskList.createSyncTask")))
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "welcome-task" }, [
              _c(
                "button",
                {
                  staticClass: "welcome-task-button",
                  class: [
                    _vm.$i18n.locale == "deutsch" ? "deu-class" : "",
                    _vm.languaArr.includes(_vm.$i18n.locale)
                      ? "other-language"
                      : ""
                  ],
                  on: {
                    click: function($event) {
                      return _vm.goToBackupPage()
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "icon task-list-icon-position cloudbackup"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "welcome-font-position" }, [
                    _vm._v(_vm._s(_vm.$t("language.taskList.createBackupTask")))
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "welcome-task" }, [
              _c(
                "button",
                {
                  staticClass: "welcome-task-button",
                  class: [
                    _vm.$i18n.locale == "deutsch" ? "deu-class" : "",
                    _vm.languaArr.includes(_vm.$i18n.locale)
                      ? "other-language"
                      : ""
                  ],
                  on: {
                    click: function($event) {
                      return _vm.goToRemotePage()
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "icon task-list-icon-position linkTask"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "welcome-font-position" }, [
                    _vm._v(_vm._s(_vm.$t("language.taskList.createRemoteTask")))
                  ])
                ]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15184d84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15184d84","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/task_list.vue
// module id = null
// module chunks = 